__webpack_require__.b = document.baseURI || self.location.href;

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"wp-runtime": 0,
	"app_assets_modules_react-partials_repos-overview_components_OverviewContent_module_css-app_as-770386": 0,
	"lazy-react-partial-actions-survey": 0,
	"lazy-react-partial-ref-selector-partial": 0,
	"lazy-react-partial-enterprise-team": 0,
	"packages_action-bar_src_OverflowMenu_module_css-packages_action-bar_src_VisibleAndOverflowCon-61352d": 0,
	"packages_action-bar_src_OverflowMenu_module_css-packages_action-bar_src_VisibleAndOverflowCon-19f366": 0,
	"lazy-react-partial-dependabot-repository-access-org-settings": 0,
	"packages_control-group_components_ControlGroupContainer_module_css-packages_control-group_com-505e2a": 0,
	"packages_copilot-animation_CopilotAnimation_module_css-packages_copilot-animation_states_Acti-c2e5e3": 0,
	"packages_action-bar_src_OverflowMenu_module_css-packages_action-bar_src_VisibleAndOverflowCon-202206": 0,
	"packages_action-bar_src_OverflowMenu_module_css-packages_action-bar_src_VisibleAndOverflowCon-463cc1": 0
};

__webpack_require__.f.j = (chunkId, promises) => {
		// JSONP chunk loading for javascript
		var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
		if(installedChunkData !== 0) { // 0 means "already installed".

			// a Promise means "currently loading".
			if(installedChunkData) {
				promises.push(installedChunkData[2]);
			} else {
				if(!/^(lazy\-react\-partial\-(c(o(de(\-scanning\-((assignees|development)\-section|alert\-dismissal)|spaces\-(business\-enablement|organization\-ownership\-setting|policy\-name\-input))|pilot\-(acti(ons\-chat\-button|vation\-progress\-bar)|c(od(e\-(guideline(\-review\-comment|s\-playground)|chat)|ing\-agent\-status)|hat)|progress\-indicator|quota\-usage|summary\-banner|user\-checklist)|nfigure\-mcp\-server\-partial)|reate\-branch\-(button|dialog)|ustom\-signup\-content)|d(ashboard\-lists|emo\-repo\-tour|ependabot\-repository\-access\-org\-settings)|enterprise\-team(|s\-table\-view)|g(lobal\-(nav\-(bar|menu)|copilot\-menu|sso\-banner)|etting\-started\-todo\-list)|in(te(gration\-permission\-selector|rnal\-api\-insights)|sights\-sidenav\-partial)|l(icensing\-(enterprise\-((|server\-)overview|cloud\-details)|(advanced\-security|copilot)\-overview)|aunch\-code)|met(adata\-suggestion\-staffbar\-component|ered\-enterprise\-server\-licenses)|re(act\-partial\-example|f\-selector\-partial|pository\-runners)|s(e(cret\-scanning\-bypass\-reviewers\-dialog|curity\-overview\-export\-button|ssions\-auth\-header)|ponsor(s\-(explore\-filter|meet\-the\-team\-list|signup)|\-org\-dependencies)|ingle\-sign\-on\-dropdown\-partial)|actions\-survey|automated\-review\-comment|keyboard\-shortcuts\-dialog|notifications\-subscriptions\-menu|nux\-dashboard\-refresh|pull\-requests\-processing\-indicator|teams\-settings\-page|webcam\-upload|your\-sponsorships)|packages_(action\-bar_src_OverflowMenu_module_css\-packages_action\-bar_src_VisibleAndOverflowCon\-(19f366|202206|463cc1|61352d)|c(hart\-card_ChartCard_module_css\-packages_chart\-card_ChartCard_Description_module_css\-d83a30|ontrol\-group_components_ControlGroupContainer_module_css\-packages_control\-group_com\-505e2a|opilot\-animation_CopilotAnimation_module_css\-packages_copilot\-animation_states_Acti\-c2e5e3)|flash\-error_FlashError_module_css\-packages_text\-expander_TextExpander_module_css\-pac\-a35192)|app_assets_modules_react\-partials_repos\-overview_components_OverviewContent_module_css\-app_as\-770386|wp\-runtime)$/.test(chunkId)) {
					// setup Promise in chunk cache
					var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
					promises.push(installedChunkData[2] = promise);

					// start chunk loading
					var url = __webpack_require__.p + __webpack_require__.u(chunkId);
					// create error before stack unwound to get useful stacktrace later
					var error = new Error();
					var loadingEnded = (event) => {
						if(__webpack_require__.o(installedChunks, chunkId)) {
							installedChunkData = installedChunks[chunkId];
							if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
							if(installedChunkData) {
								var errorType = event && (event.type === 'load' ? 'missing' : event.type);
								var realSrc = event && event.target && event.target.src;
								error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
								error.name = 'ChunkLoadError';
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							}
						}
					};
					__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
				} else installedChunks[chunkId] = 0;
			}
		}
};

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = globalThis["webpackChunk_github_ui_github_ui"] = globalThis["webpackChunk_github_ui_github_ui"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));